import DetailInfo from './detailinfo.vue'
import Item from './item.vue'
export { DetailInfo, Item }
